import React from 'react'
import '../../stylesheets/FilterListSS.css'

function FilterList({ setFilter, update, reset }) {
    function forceUndefined(){
        update(undefined);
    }
    return (
        <div id='filter_container'>
            <section id='filter_section'>
                <label>Topic</label><input type='text' className='filter'></input>
                <label>Date</label><input type='date' className='filter'></input>
                <div id='button'>
                    <button onClick={reset}>Reset</button>
                    <button onClick={forceUndefined}>Search</button>
                </div>
            </section>
        </div>
    )
}

export default FilterList